import { Stack } from "@mantine/core";
import type { JSX } from "react";
import { usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { useProductOfferStore } from "@/sales-tools";
import { DetectedCues } from "@/sales-tools/detected-cues/DetectedCues";
import { useSessionId } from "@/sdk";
import { CustomerLocation } from "./CustomerLocation";
import { DigitalCompetency } from "./digital-competency/DigitalCompetency";

export function CustomerInsights(): JSX.Element | null {
    const sessionId = useSessionId();
    const { isDigitalCompetencyInsightEnabled } = usePartnerFeatureConfigured();
    const products = useProductOfferStore((state) => state.getProducts(sessionId));
    const hasProducts = products.length > 0;
    return (
        <Stack p="sm" pt="sm" gap="sm">
            <CustomerLocation />
            {hasProducts && <DetectedCues />}
            {isDigitalCompetencyInsightEnabled && <DigitalCompetency />}
        </Stack>
    );
}
